import styled from "styled-components";

export const VideoFrameContainer = styled.div<{ $small?: boolean }>`
  width: 100%;
  height: ${({ $small }) => ($small ? "423px" : "612px")};
  background-color: ${({ theme }) => theme.colors.primary[400]};
  ${({ theme }) => theme.breakpoints.lg.query} {
    width: 100%;
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    height: 309px;
  }
`;
